import type {
  MessageResultDTO,
  MessageResultV2DTO,
} from '@nora-monorepo/nora-api-client';

import { useChatUserStore } from '#nora-chat-ui/stores/user-store';

export function isMessageResultV2DTO(
  message: MessageResultDTO | MessageResultV2DTO,
): message is MessageResultV2DTO {
  return !('sentByUserId' in message);
}

export function convertToMessageResultV2(
  message: MessageResultDTO | MessageResultV2DTO,
): MessageResultV2DTO {
  if (isMessageResultV2DTO(message)) {
    return message;
  }

  const userStore = useChatUserStore();
  const userId = userStore.getUserId;
  if (!userId) {
    throw new Error('User ID is not available');
  }

  const reactionsMap = new Map<string, number>();
  message.reactions?.forEach((reaction) => {
    const reactionCount = reactionsMap.get(reaction.reaction);
    if (reactionCount) {
      reactionsMap.set(reaction.reaction, reactionCount + 1);
    }
    else {
      reactionsMap.set(reaction.reaction, 1);
    }
  });
  const reactions = Array.from(reactionsMap.entries()).map(
    ([reaction, count]) => ({
      reaction,
      count,
    }),
  );

  message.readMessages = message.readMessages ?? [];
  const isRead = message.readMessages.some(
    readMessage => readMessage.userId === userId,
  );

  const readMessagesCount = isRead
    ? message.readMessages?.length - 1
    : message.readMessages?.length;

  const convertedMessage: MessageResultV2DTO = {
    ...message,
    readMessagesCount,
    reactions,
    isRead,
  };

  return convertedMessage;
}
